import { HelpTooltip } from '@app/components/various/HelpTooltip';
import { Tooltip } from '@app/components/various/Tooltip';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import React from 'react';

interface Props {
  name: string;
  fieldName: string;
  description?: string;
}

export const ContentItemName = ({ name, fieldName, description }: Props) => {
  const ref = React.useRef<HTMLSpanElement>(null);
  const isOverflowing = useIsOverflowing(ref);

  return (
    <span className="flex min-h-10 max-w-60 items-center justify-between gap-2 break-words rounded-regular bg-neutral-96 px-3 py-2 body-2">
      <Tooltip content={isOverflowing && name}>
        <span ref={ref} className="truncate">
          {name}
        </span>
      </Tooltip>
      <HelpTooltip
        content={
          <span className="flex flex-col">
            <span>{fieldName}</span>
            {isDefined(description) && <span>{description}</span>}
          </span>
        }
      />
    </span>
  );
};
